import {useState} from "react";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { useMsal } from "@azure/msal-react";
import axios from 'axios';
import AttachFileSharpIcon from '@mui/icons-material/AttachFileSharp';
import './Upload.css';

export default function Upload() {
    const [open, setOpen] = useState(false); 
    const [file, setFile] = useState('');
    const [fileStatus, setFileStatus] = useState('');

    let url = 'https://atci.lkm.eitacademy.accenture.com/ips-apis/sap/upload';
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    let ipsLoggedInEnterpriseId = '';

    const handleOpen = () => {
        setFile('');
        setFileStatus();
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };    
    
    if (activeAccount) {
        ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
    }

    const handleChange = (e) => {        
        if(e.target.files[0].type !== 'application/pdf') {
            setFileStatus('invalid');
            setFile('');
            return;                                        
        }        
        setFileStatus('');       
        setFile(e.target.files[0]); 
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const formData = new FormData();        
        formData.append('file', file);        
        formData.append('enterprise_id', ipsLoggedInEnterpriseId);        
        
        if (process.env.NODE_ENV === 'development') {
            url = 'http://localhost:3001/sap/upload';
            // alert(`you are not allowed to upload a file from development environment.`);
            // return;
        }
        
        axios.post(
            url,
            formData,
            {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': localStorage.getItem("token")                
                }
        })
        .then(res => {                
            setFileStatus('success');
            setFile('');
            setTimeout(() => {
                setFileStatus('');
            }, 2000)
        })
        .catch(err => setFileStatus('failed'))
    }

    return <>
        <Modal open={open}>                
            <Box className="sap-btp-model-container">
                <div>                                            
                    <span className="sap-btp-model-close-btn" onClick={handleClose}>
                        <AiOutlineCloseCircle />
                    </span>                    
                    <form onSubmit={handleSubmit} className="track-file-upload-form">
                        <input type="file" onChange={handleChange} id="track-file" hidden />                        
                        <label for="track-file" className='track-file-upload-label'>                            
                            {file === '' ? <div className='track-choose-file-content'>
                                <AttachFileSharpIcon />
                                <span>Choose PDF file</span>
                            </div> : file.name.substring(0,15)+'...'}
                        </label>
                        {file !== '' && <button type="submit" className='track-file-upload-btn'>
                            <img src={process.env.PUBLIC_URL + "/images/SAP/special_programs/upload.png"} alt="upload" />
                            <span className='track-file-upload-btn-text'>Upload</span>
                        </button>}
                    </form>                                        
                    {fileStatus !== '' && <div className='track-upload-status'>
                        {fileStatus === 'success' && <span className='track-upload-success-status'>File uploaded successfully.</span>}
                        {fileStatus === 'failed' && <span className='track-upload-failed-status'>Failed to submit!</span>}
                        {fileStatus === 'invalid' && <span className='track-upload-invalid-status'>upload only PDF file!</span>}
                    </div>}                                        
                </div>
            </Box>
        </Modal>
        <button onClick={handleOpen} className="sap-btp-upload">Upload</button>
    </>
}